import type { TokaMapInstance } from '@tokamap/core';
import React                    from 'react';
import View                     from '@widesk-ui/components/View';
import leftSidebarStore         from '@/TokamapEditor/stores/leftSidebarStore';

/** Nombre de formes dans la sélection multiple courante (BESOINS.md §13, rectangle de drag) — pas
 * affiché tant qu'aucune sélection multiple n'est active (`@tokamap/core` émet `selection:changed`
 * à chaque changement de composition, voir `MapLibreAdapter`). */
export default function SelectionCount({ instance }: { instance: TokaMapInstance | null }) {
	const [count, setCount] = React.useState(0);

	React.useEffect(() => {
		if (!instance) return;

		return instance.mapAdapter.on((event) => {
			if (event.type !== 'selection:changed') return;
			setCount(event.shapeIds.length);
		});
	}, [instance]);

	if (count === 0) return null;

	return (
		<View
			className="selection-count"
			color="white"
			px="sm"
			py={4}
			pointer
			style={{ borderRadius: 100, textDecoration: 'underline', textDecorationStyle: 'dotted', textUnderlineOffset: 3 }}
			hover={{ bg: '#393A40' }}
			// Inconditionnel : la garde `if (!opened)` d'origine rendait ce libellé inerte dès qu'une
			// sidebar était ouverte — ce qui est devenu le cas courant, la sélection composée depuis une
			// liste (bouton "N zones liées") la laissant désormais en place. Cliquer ici est une demande
			// explicite, elle prime donc sur ce qui est affiché.
			onClick={() => leftSidebarStore.openFeatureSettings()}
		>
			{count} forme{count > 1 ? 's' : ''} sélectionnée{count > 1 ? 's' : ''}
		</View>
	);
}
